import axios from 'axios';
import config from "../../config";
import { headers_get } from "../../main_components/tokens/get_headers_user";

const BASE_URL = `${config?.URL_CONFIGURATION}`;

const request = async (method, endpoint, data = null) => {
    const url = `${BASE_URL}${endpoint}`;
    try {
        const headers = await headers_get();
        return await axios({ method, url, data, headers });
    } catch (error) {
        console.error(`Error in ${method.toUpperCase()} ${url}:`, error?.response?.data || error.message);
        throw error;
    }
};

// Funciones para interactuar con los endpoints de usuarios
export const users_get = async () => {
    return request('get', '/od/users');
};

export const users_getById = async (id) => {
    return request('get', `/od/users/${id}`);
};

export const users_post = async (data) => {
    return request('post', '/od/users', data);
};

export const users_put = async (id, data) => {
    return request('put', `/od/users/${id}`, data);
};

export const users_delete = async (id) => {
    return request('delete', `/od/users/${id}`);
};
